export const initialize = () => {};
export const setCustomSessionId = () => {};
export const setCustomUserId = () => {};
export const setCustomTag = () => {};
export const pause = () => {};
export const resume = () => {};
export const setEnabled = () => {};
export const getCurrentSessionId = () => Promise.resolve('');
